import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import { withStyles } from '@material-ui/core/styles'
import React, { useState } from 'react'
import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'
import { deleteInternalCodes } from '../../../gql/deleteInternalCodes'
import { generateCampaignInternalCodes } from '../../../gql/generateCampaignInternalCodes'
import InternalCodeUploadPopup from '../../Popups/CodeUploadPopups/InternalCodes'
import ConfirmationPopup from '../../Popups/ConfirmationPopup'
import styles from './styles'
import { insertCampaignLogs } from '../../../../../../../Logs/campaign/gql'
import {
  CAMPAIGN_LOG_ENUM_TYPES,
  CAMPAIGN_ENUM_TYPES,
} from '../../../../../../../shared/constants'
import { createEDDMInternalFlyerCodes } from '../../../../../../Country/Page/Pipeline/PipelineView/graphQL'

const InternalCodesButtons = ({
  classes,
  // campaigns,
  mapInternalCodesTable,
  isCodesUploading,
  setIsCodesUploading,
  selectedRows,
  onCodesDeleted,
  isActionsDisabled,
  // onRefetch,
  isCodesExist,
  campaignType,
}) => {
  const { campaignId } = useParams()

  const [isCodeUploadPopupOpen, setIsCodeUploadPopupOpen] = useState(false)
  const [
    isDeleteConfirmationPopupOpen,
    setIsDeleteConfirmationPopupOpen,
  ] = useState(false)
  const [
    isUploadConfirmationPopupOpen,
    setIsUploadConfirmationPopupOpen,
  ] = useState(false)
  const [
    isGenerateCodesConfirmationPopupOpen,
    setIsGenerateCodesConfirmationPopupOpen,
  ] = useState(false)
  const [isCodesGenerating, setIsCodesGenerating] = useState(false)
  const [isCodesDeleting, setIsCodesDeleting] = useState(false)

  const onDelete = async () => {
    setIsCodesDeleting(true)
    try {
      const response = await deleteInternalCodes({
        campaignId: campaignId,
        codeIds: selectedRows,
      })
      const result = await response.json()
      const codes = result.data.deleteInternalCodes.internalCodes
      mapInternalCodesTable(codes)
      await insertCampaignLogs([
        {
          campaignId,
          type: CAMPAIGN_LOG_ENUM_TYPES.DELETE_CODES,
          additionalInfo: selectedRows.join(','),
        },
      ])
    } catch (e) {
      console.error({ e })
    } finally {
      setIsCodesDeleting(false)
      setIsDeleteConfirmationPopupOpen(false)
      setIsUploadConfirmationPopupOpen(false)
      setIsGenerateCodesConfirmationPopupOpen(false)
      onCodesDeleted()
    }
  }

  const onGenerateCodes = async () => {
    setIsCodesGenerating(true)
    if (campaignType === CAMPAIGN_ENUM_TYPES.DIRECTMAIL) {
      const createCodesRequest = await createEDDMInternalFlyerCodes({
        campaignId,
      })

      const {
        data: {
          createEDDMInternalFlyerCodes: { success },
        },
      } = await createCodesRequest.json()

      if (success) {
        await insertCampaignLogs([
          {
            campaignId,
            type: CAMPAIGN_LOG_ENUM_TYPES.GENERATE_CODES,
          },
        ])
        window.location.reload()
      }
    } else {
      try {
        const response = await generateCampaignInternalCodes({
          campaignId: campaignId,
        })
        const result = await response.json()
        const codes = result.data.generateInternalCodes.internalCodes
        mapInternalCodesTable(codes)
        await insertCampaignLogs([
          {
            campaignId,
            type: CAMPAIGN_LOG_ENUM_TYPES.GENERATE_CODES,
          },
        ])
      } catch (e) {
        console.error({ e })
      } finally {
        setIsCodesGenerating(false)
      }
    }
  }

  return (
    <div className={classes.controlsBlock}>
      <InternalCodeUploadPopup
        isOpen={isCodeUploadPopupOpen}
        onClose={() => setIsCodeUploadPopupOpen(false)}
        mapInternalCodesTable={mapInternalCodesTable}
        campaignId={campaignId}
        isCodesUploading={isCodesUploading}
        setIsCodesUploading={setIsCodesUploading}
      />
      <ConfirmationPopup
        onCancel={() => {
          setIsDeleteConfirmationPopupOpen(false)
        }}
        isOpen={isDeleteConfirmationPopupOpen}
        onConfirm={onDelete}
        isInProgress={isCodesDeleting}
      />
      <ConfirmationPopup
        onCancel={() => {
          setIsUploadConfirmationPopupOpen(false)
        }}
        isOpen={isUploadConfirmationPopupOpen}
        onConfirm={() => {
          setIsCodeUploadPopupOpen(true)
          setIsUploadConfirmationPopupOpen(false)
        }}
        body="Are you sure you want to proceed? Existing data will be overwritten."
        title="Confirm Upload"
      />
      <ConfirmationPopup
        onCancel={() => {
          setIsGenerateCodesConfirmationPopupOpen(false)
        }}
        isOpen={isGenerateCodesConfirmationPopupOpen}
        onConfirm={() => {
          onGenerateCodes()
          setIsGenerateCodesConfirmationPopupOpen(false)
        }}
        body="Are you sure you want to proceed? Existing data will be overwritten."
        title="Confirm Code Generation"
      />

      <div className={classes.buttons}>
        <Button
          className={classes.button}
          variant="outlined"
          onClick={
            isCodesExist
              ? () => setIsGenerateCodesConfirmationPopupOpen(true)
              : onGenerateCodes
          }
          disabled={isActionsDisabled || isCodesDeleting || isCodesGenerating}
        >
          {isCodesGenerating ? <CircularProgress size={20} /> : null} Generate
          Codes
        </Button>
        {/* <Button */}
        {/*   disabled={isActionsDisabled || isCodesDeleting || isCodesGenerating} */}
        {/*   className={classes.button} */}
        {/*   variant="outlined" */}
        {/*   onClick={ */}
        {/*     isCodesExist */}
        {/*       ? () => setIsUploadConfirmationPopupOpen(true) */}
        {/*       : () => setIsCodeUploadPopupOpen(true) */}
        {/*   } */}
        {/* > */}
        {/*   Upload Codes */}
        {/* </Button> */}
        <Button
          className={classes.button}
          variant="outlined"
          disabled={
            isActionsDisabled ||
            isCodesDeleting ||
            isCodesGenerating ||
            !selectedRows.length
          }
          onClick={() => {
            setIsDeleteConfirmationPopupOpen(true)
          }}
        >
          Delete
        </Button>
      </div>
    </div>
  )
}

const mapStateToProps = (state, props) => ({
  campaigns: state.campaigns.campaigns,
  state: state,
})

export default connect(mapStateToProps)(
  withStyles(styles)(InternalCodesButtons),
)
